export default __webpack_public_path__ + "static/banner-d22936c98293786a313d0ae144bc7df6.png";